import { PayloadFilterExternalValidations } from "../../../../../../hooks/filter/typing"
import { removeAllReference } from "../../../../../../utils/methods/removedReference"
import { Item } from "../../../../../../utils/types/generals"

export const formatUserMapFilter = {
    from: 'start_date',
    to: 'end_date',
    role: 'role_ids',
    division: 'division_ids',
    users: 'user_ids',
    user: 'user_ids',
    userType: 'user_type_ids',
    area: 'areas_ids',
    department: 'departments_ids',
    stores: 'store_ids',
    store: 'store_ids',
    status: 'status_ids',
}

export const validateItemsMain = ({ name, body, departmentItem, setFilterData }: PayloadFilterExternalValidations & { departmentItem: Item[] }) => {
    let localeBody: Record<string, any> = removeAllReference(body)
    if (name === 'area') {
        const { area, departments: departmentsData } = localeBody
        const filteredDepartment = departmentsData?.filter((department: any) => area.find((area: any) => area.value == department.areaId))
        let depatmentList: Item[] = []

        area?.forEach((area: any) => {
            const id = area.value
            const childs = departmentItem?.filter((department) => department.areaId == id) || []
            depatmentList?.push(...childs)
        })

        setFilterData((prev) => ({
            ...prev,
            departments: filteredDepartment,
        }))

        localeBody = { ...localeBody, departments: filteredDepartment, }
        return { localeBody, depatmentList }
    }

    return { localeBody, depatmentList: departmentItem }
}